export default __webpack_public_path__ + "static/project-slide-7-415-700-26ff016feb100a72855fc50118f82126.webp";